import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MyFormStoreEffects } from './my-form-store.effects';
import { myFormInitialState, myFormReducer } from './my-form-store.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('myForm', myFormReducer, {
      initialState: myFormInitialState
    }),
    EffectsModule.forFeature([MyFormStoreEffects])
  ]
})
export class MyFormStoreModule {}
